import { Box, Text } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { useColorModeVariables } from 'components/colorModeVarialbels/ColorModeValues';
import CommonPagination from 'components/commonPagination/CommonPagination';
import CommonTable from 'components/commonTable/CommonTable';
import moment from 'moment';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetSystemErrorList } from 'reactRedux/thunks/systemErrorThunk/systemErrorThunk';
import useListState from 'hooks/useListState';

const SystemErrorsList = () => {
  const dispatch = useDispatch();
  const { tabletextColor } = useColorModeVariables();
  const { params, setParams, page, setPage } = useListState({
    defaults: { limit: 10 },
  });
  const { isLoading, errorListData } = useSelector(
    (state) => state.SystemErrorSlice,
  );

  const getSystemErrorList = useCallback(() => {
    dispatch(
      GetSystemErrorList({
        page: page,
        limit: params.limit || 10,
      }),
    );
  }, [dispatch, page, params.limit]);

  useEffect(() => {
    getSystemErrorList();
  }, [getSystemErrorList]);

  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor((row) => row?.createdAt, {
      id: 'createdAt',
      header: () => (
        <Text
          whiteSpace="nowrap"
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          fontFamily="Montserrat"
        >
          Generated Date
        </Text>
      ),
      cell: (info) => {
        const createdAt = info.getValue();
        const formattedDateTime = moment
          .parseZone(createdAt)
          .format('DD-MM-YYYY HH:mm:ss');

        return (
          <Text
            color={tabletextColor}
            fontSize="sm"
            fontWeight="600"
            align="left"
          >
            {formattedDateTime}
          </Text>
        );
      },
    }),
    columnHelper.accessor((row) => row?.errorCode, {
      id: 'errorCode',
      header: () => (
        <Text
          whiteSpace="nowrap"
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          fontFamily="Montserrat"
        >
          Error Code
        </Text>
      ),
      cell: (info) => (
        <Text
          color={tabletextColor}
          fontSize="sm"
          fontWeight="600"
          align="left"
        >
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor((row) => row?.path, {
      id: 'path',
      header: () => (
        <Text
          whiteSpace="nowrap"
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          fontFamily="Montserrat"
        >
          path
        </Text>
      ),
      cell: (info) => (
        <Text
          color={tabletextColor}
          fontSize="sm"
          fontWeight="600"
          align="left"
        >
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor((row) => row?.method, {
      id: 'method',
      header: () => (
        <Text
          whiteSpace="nowrap"
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          fontFamily="Montserrat"
        >
          Method
        </Text>
      ),
      cell: (info) => (
        <Text
          color={tabletextColor}
          fontSize="sm"
          fontWeight="600"
          align="left"
        >
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor((row) => row?.errorMessage, {
      id: 'errorMessage',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          fontFamily="Montserrat"
          whiteSpace="nowrap"
        >
          Error Message
        </Text>
      ),
      cell: (info) => (
        <Text
          color={tabletextColor}
          fontSize="sm"
          fontWeight="600"
          align="left"
        >
          {info.getValue()}
        </Text>
      ),
    }),
    // columnHelper.accessor((row) => row?.stackTrace, {
    //   id: 'stackTrace	',
    //   header: () => (
    //     <Text
    //       align="left"
    //       fontSize={{ sm: '10px', lg: '12px' }}
    //       color="gray.400"
    //       fontFamily="Montserrat"
    //       whiteSpace="nowrap"
    //     >
    //       Stack Trace
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Text
    //       color={tabletextColor}
    //       fontSize="sm"
    //       fontWeight="600"
    //       align="left"
    //     >
    //       {info.getValue()}
    //     </Text>
    //   ),
    // }),
  ];

  return (
    <>
      <Box pt={{ base: '60px', md: '80px', xl: '80px' }}>
        <CommonTable
          columns={columns}
          data={errorListData?.list}
          isLoading={isLoading}
          keyValue="id"
          rowclick={['actions', 'status']}
          excludes={['actions', 'status']}
          dynamicWidth={{
            createdAt: '100px',
            errorCode: '100px',
            path: '200px',
            method: '100px',
            errorMessage: '500px',
          }}
        />

        {/* {errorListData?.total > 10 && ( */}
        <CommonPagination
          totalCount={errorListData?.total}
          activePage={page}
          pageCount={Math.ceil(errorListData?.total / errorListData?.limit)}
          onPageChange={setPage}
          itemsPerPage={params.limit || 10}
          onItemsPerPageChange={(newLimit) => {
            setParams({ limit: newLimit, page: 1 });
          }}
        />
        {/* )} */}
      </Box>
    </>
  );
};

export default SystemErrorsList;
